import {useCSS} from '@pinecast/styles';
import {defineMessages, useIntl} from '@pinecast/i18n';
import {MOBILE} from './mobile';
import {useTheme} from './ThemeProvider';
import {contrastColor} from '@pinecast/common/color';
import useAudioState from './useAudioState';

const messages = defineMessages({
  play: {
    id: 'pl-spa.PlayPause.play',
    description: 'Play button label',
    defaultMessage: 'Play',
  },
  pause: {
    id: 'pl-spa.PlayPause.pause',
    description: 'Pause button label',
    defaultMessage: 'Pause',
  },
});

type Props = {
  audio: HTMLAudioElement;
  onPlay: () => void;
  onPause: () => void;
};

const PlayPause = ({audio, onPlay, onPause}: Props) => {
  const css = useCSS();
  const intl = useIntl();

  const theme = useTheme();

  const state = useAudioState(audio);

  const iconColor = contrastColor(theme.accentColor);

  return (
    <button
      aria-label={intl.formatMessage(
        state === 'paused' ? messages.play : messages.pause,
      )}
      className={css({
        alignItems: 'center',
        appearance: 'none',
        background: theme.accentColor,
        border: 0,
        borderRadius: '8px',
        boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        height: '32px',
        marginRight: '8px',
        justifyContent: 'center',
        width: '40px',
        transform: 'translate(0, 0)',
        transition: 'transform 0.1s, height 0.2s, width 0.2s',
        ':active': {
          boxShadow: '0 0.5px 1px rgba(0, 0, 0, 0.1)',
          transform: 'translate(0, 2px)',
        },
        [MOBILE]: {
          height: '24px',
          width: '32px',
        },
      })}
      onClick={() => (state === 'playing' ? onPause() : onPlay())}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 256 256"
      >
        <g style={{display: state !== 'paused' ? 'none' : undefined}}>
          <path
            d="M99.535 210.813c-2.74 0-5.48-.707-7.944-2.13-4.916-2.835-7.943-8.086-7.943-13.758V57.992c0-5.68 3.027-10.924 7.944-13.76 4.918-2.844 10.972-2.844 15.89 0l95.33 68.463c4.916 2.836 7.943 8.087 7.943 13.76 0 5.68-3.027 10.923-7.944 13.76l-95.33 68.47c-2.463 1.42-5.204 2.128-7.945 2.128"
            fill={iconColor}
          />
        </g>
        <g style={{display: state !== 'playing' ? 'none' : undefined}}>
          <rect x="75" y="65" width="40" height="120" fill={iconColor} />
          <rect x="145" y="65" width="40" height="120" fill={iconColor} />
        </g>
      </svg>
    </button>
  );
};

export default PlayPause;
